// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__25hmU","wide":"style_wide__35Qdi","buttons":"style_buttons__3ym_J"};